import { selectExperiment } from '../../../../../ui-kitchen/src/components/Experiments/useExperiment';
import { RESY_WEB_REWARDS_MARKETING_PAGE } from '../../../../../ui-kitchen/src/constants/optimizelyExperiments';

const selectIsResyRewardsEnabled = (state) => (
  selectExperiment(state, RESY_WEB_REWARDS_MARKETING_PAGE).enabled ?? false
);

export default selectIsResyRewardsEnabled;
